export default "__VITE_ASSET__DodhRQU0__"